var _g, _defs;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRawUrlsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10449_10254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7144 19.0856C15.3168 19.0856 19.0478 15.3547 19.0478 10.7523C19.0478 6.14991 15.3168 2.41895 10.7144 2.41895C6.11206 2.41895 2.3811 6.14991 2.3811 10.7523C2.3811 15.3547 6.11206 19.0856 10.7144 19.0856Z",
    stroke: "#1A22E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.3811 10.7529H19.0478",
    stroke: "#1A22E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7144 2.41895C12.7988 4.70091 13.9834 7.66231 14.0478 10.7523C13.9834 13.8423 12.7988 16.8037 10.7144 19.0856C8.63004 16.8037 7.44548 13.8423 7.3811 10.7523C7.44548 7.66231 8.63004 4.70091 10.7144 2.41895Z",
    stroke: "#1A22E4",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10449_10254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.714355 0.75293)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRawUrlsIcon);
export default __webpack_public_path__ + "static/media/raw-urls-icon.9a933e497721d7cb890575874f02d1c8.svg";
export { ForwardRef as ReactComponent };